var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_839_2652)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2317 2.82979C14.9209 3.01113 15.4586 3.54207 15.645 4.22009C16.1325 6.15444 16.1007 9.81155 15.6552 11.7762C15.4709 12.4542 14.9311 12.9831 14.2419 13.1664C12.2961 13.6399 3.58078 13.5815 1.74759 13.1664C1.05836 12.9851 0.520691 12.4542 0.3343 11.7762C-0.125534 9.93242 -0.093787 6.03354 0.324059 4.23017C0.508396 3.55214 1.04812 3.02322 1.73735 2.83986C4.33863 2.3059 13.3059 2.47818 14.2317 2.82979ZM6.44833 5.64062L10.6268 7.99809L6.44833 10.3556V5.64062Z",
    fill: "#B5B7BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_839_2652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactYoutube);
export default __webpack_public_path__ + "static/media/contact_youtube.b2eed257756c60f4e0c273bf87531a96.svg";
export { ForwardRef as ReactComponent };